import { useApolloClient } from '@apollo/client';
import { Button, Divider } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import RootDomains from './RootDomains';
import { ANTD_GRAY_V2 } from '../../entity/shared/constants';
import CreateDomainModal from '../CreateDomainModal';
import { updateListDomainsCache } from '../utils';
import { useDomainsContext } from '../DomainsContext';
import { useTranslation } from '../../../i18n/useTranslation';

const PageWrapper = styled.div`
    flex: 1;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    height: calc(100vh - 200px);
    background-color: ${ANTD_GRAY_V2[11]};
`;

const Header = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 8px 16px;
    font-size: 30px;
    align-items: center;
`;

export default function ManageDomainsPageV2() {
    const { setEntityData, setParentDomainsToUpdate } = useDomainsContext();
    const [isCreatingDomain, setIsCreatingDomain] = useState(false);
    const client = useApolloClient();
    const { t } = useTranslation();

    useEffect(() => {
        setEntityData(null);
    }, [setEntityData]);

    return (
        <PageWrapper className="f-height-auto-xs">
            <Header>
                <Button
                    type="primary"
                    onClick={() => setIsCreatingDomain(true)}
                    data-testid="domains-new-domain-button"
                    aria-label={t('New Domain')}
                >
                    <PlusOutlined aria-hidden="true" /> {t('New Domain')}
                </Button>
            </Header>
            <Divider className="my-0" />
            <RootDomains />
            {isCreatingDomain && (
                <CreateDomainModal
                    onClose={() => setIsCreatingDomain(false)}
                    onCreate={(urn, id, name, description, parentDomain) => {
                        updateListDomainsCache(client, urn, id, name, description, parentDomain);
                        if (parentDomain) setParentDomainsToUpdate([parentDomain]);
                    }}
                />
            )}
        </PageWrapper>
    );
}
